import { Radio, Tabs } from 'antd';
import React from 'react'
import map from '../assets/orange-map.png'
import aslkahawaii from '../assets/aslkahawaii.png'
import Tab from './Tab';

const HowItsWork = () => {

    const items = [
        {
            key: "1",
            label: "By State",
            children: <div>Your By State Content</div>,
        },
        {
            key: "2",
            label: "By Metro",
            children: <div>Your By Metro Content</div>,
        },
        {
            key: "3",
            label: "List Details",
            children: <div>Your List Details Content</div>,
        },
    ];


    return (
        <div className="py-16 bg-[#FFFFFF]">
            <div className="max-w-6xl mx-auto px-4">
                <div className="text-center mb-12">
                    <p className="text-3xl font-bold text-[#4E6978] mb-4">How it works</p>
                    <div className='mt-5'>
                    <p className="text-xl font-medium text-gray-600 ">
                        New businesses Now makes the list creation process easy. You can create and download the perfect list<br />  in minutes.
                    </p>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 px-6">
                    <div className="flex justify-center">
                        <p className='text-xl font-bold text-[#4E6978] mb-2'>1.</p>
                        <p className="text-xl font-bold text-[#4E6978] mb-2 ml-2">Enter in your <br /> geography.</p>
                    </div>

                    <div className="flex justify-center">
                        <p className='text-xl font-bold text-[#4E6978] mb-2'>2.</p>
                        <p className="text-xl font-bold text-[#4E6978] mb-2 ml-2">Review list <br /> details.</p>
                    </div>

                    <div className="flex justify-center">
                        <p className='text-xl font-bold text-[#4E6978] mb-2'>3.</p>
                        <p className="text-xl font-bold text-[#4E6978] mb-2 ml-2">Enter Payment <br /> details.</p>
                    </div>

                    <div className="flex justify-center">
                        <p className='text-xl font-bold text-[#4E6978] mb-2'>4.</p>
                        <p className="text-xl font-bold text-[#4E6978] mb-2 ml-2">Download list.</p>
                    </div>

                </div>

                <Tab/>

            </div>
        </div>
    )
}

export default HowItsWork